module.exports = __webpack_public_path__ + "static/media/fa-solid-900.da6cb261.woff";